import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class extends HttpRequest {
  /**
   * @param {object} query e.g. { is_default: 1, channel: 'web', tag: 'Jewery' }
   */
  getMany (query) {
    this.setHeader(getAuthToken())
    return this.get('/order-fulfillment-settings-new', query)
  }

  /**
   * Save Default rule (UI shape) — backend จะวน 4 channels ให้
   * payload: { warehouses: [{ id, name, priority, channels: { <ch>: { status, minStock } } }] }
   */
  saveDefaultGrouped (payload) {
    this.setHeader(getAuthToken())
    return this.put('/order-fulfillment-settings-new/grouped/default', payload)
  }

  /**
   * Save Custom rules ทั้งหมด (priority + warehouse setup)
   * payload: { rules: [{ tag, priority, warehouses: [{ id, name, priority, channels: { <ch>: { status, minStock } } }] }] }
   */
  saveCustomGrouped (payload) {
    this.setHeader(getAuthToken())
    return this.put('/order-fulfillment-settings-new/grouped/custom', payload)
  }

  /**
   * Create custom rule ใหม่ — backend จะ create 1 doc per channel
   */
  createTagRule (payload) {
    this.setHeader(getAuthToken())
    return this.post('/order-fulfillment-settings-new/grouped/custom', payload)
  }

  /**
   * Rename tag — backend update 1 doc per channel
   */
  renameTag (oldTag, newTag) {
    this.setHeader(getAuthToken())
    return this.patch(`/order-fulfillment-settings-new/grouped/custom/${oldTag}/rename`, { tag: newTag })
  }

  /**
   * ลบ tag rule ทั้งหมด (soft-delete 1 doc per channel)
   */
  deleteByTag (tag) {
    this.setHeader(getAuthToken())
    return this.delete(`/order-fulfillment-settings-new/grouped/custom/${tag}`)
  }
}
